import CarAssumptionsPage from './CarAssumptionsPage';

export default CarAssumptionsPage;
